import DashboardCard from '../../../../../components/dashboard-card/EndToEndCard.tsx/DashboardCard';
import CompanyDetailSubsection from './components/CompanyDetailSubsection/CompanyDetailSubsection';

const CompanyProfile = () => (
  <DashboardCard
    renderComponent={<CompanyDetailSubsection />}
    renderComponentSx={{ m: '0 !important' }}
    sx={{ width: { md: '100%' } }}
  />
);
export default CompanyProfile;
